import { render, staticRenderFns } from "./selectPages.vue?vue&type=template&id=ed61b362&"
import script from "./selectPages.vue?vue&type=script&lang=js&"
export * from "./selectPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports